<div
  class="om-waveform-recorder"
  [class.om-waveform-recorder--readonly]="readOnly()"
>
  <input
    id="waveformRecorderFileInput"
    type="file"
    accept="audio/*"
    class="hidden"
    (change)="onFileUpload($event)"
  />

  @if (readOnly()) {
  <div class="playback-compact">
    @if (state() === 'playing' || state() === 'paused') {
    <button
      type="button"
      class="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center shadow-lg shadow-primary/25 hover:bg-primary/90 active:scale-95 transition-all cursor-pointer shrink-0"
      (click)="pause()"
      aria-label="Pause"
    >
      <span
        class="material-symbols-outlined flex items-center justify-center !text-[22px] leading-none"
        >pause</span
      >
    </button>
    } @else {
    <button
      type="button"
      class="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center shadow-lg shadow-primary/25 hover:bg-primary/90 active:scale-95 transition-all cursor-pointer shrink-0"
      (click)="play()"
      aria-label="Play"
    >
      <span
        class="material-symbols-outlined flex items-center justify-center !text-[22px] leading-none"
        >play_arrow</span
      >
    </button>
    }
    <div
      class="playback-waveform flex-1 min-w-[120px] w-full waveform-canvas"
      [style.height.px]="height()"
      [style.min-height.px]="height()"
      #waveformContainer
    ></div>
    <span class="text-sm text-slate-500 dark:text-slate-400 font-mono shrink-0">
      {{ formattedDuration() }}
    </span>
  </div>
  } @else { @switch (state()) { @case ('idle') {
  <div class="flex flex-col gap-3">
    <div class="flex items-center gap-3">
      <button
        type="button"
        class="w-14 h-14 rounded-full bg-primary text-white flex items-center justify-center shadow-lg shadow-primary/25 hover:bg-primary/90 active:scale-95 transition-all cursor-pointer shrink-0"
        (click)="startRecording()"
        aria-label="Record audio"
      >
        <span
          class="material-symbols-outlined flex items-center justify-center !text-[24px] leading-none"
          >mic</span
        >
      </button>
      <div class="flex-1 min-w-0">
        <p class="text-base font-semibold text-slate-700 dark:text-slate-300">
          {{ title() || 'Audio' }}
        </p>
        <p class="text-sm text-slate-400 dark:text-slate-500 mt-0.5">
          Toca el micrófono para grabar
        </p>
      </div>
    </div>
    <button
      type="button"
      class="w-full rounded-xl border border-white/50 dark:border-white/[0.15] bg-white/60 dark:bg-white/[0.06] backdrop-blur-sm hover:bg-white/80 dark:hover:bg-white/[0.12] text-slate-500 dark:text-slate-400 hover:text-primary dark:hover:text-primary transition-all cursor-pointer flex items-center justify-center gap-2 px-4 py-2.5"
      (click)="triggerUpload()"
      aria-label="Upload audio"
    >
      <span
        class="material-symbols-outlined flex items-center justify-center !text-[18px] leading-none"
        >upload_file</span
      >
      <span class="text-sm font-medium">Subir archivo de audio</span>
    </button>
  </div>
  } @case ('recording') {
  <div class="flex items-center gap-3">
    <button
      type="button"
      class="w-14 h-14 rounded-full bg-red-500 text-white flex items-center justify-center shadow-lg shadow-red-500/25 animate-pulse hover:bg-red-600 active:scale-95 transition-all cursor-pointer shrink-0"
      (click)="stopRecording()"
      aria-label="Stop recording"
    >
      <span
        class="material-symbols-outlined flex items-center justify-center !text-[24px] leading-none"
        >stop</span
      >
    </button>
    <div class="flex-1 min-w-0">
      <p class="text-base font-semibold text-red-500 flex items-center gap-1.5">
        <span class="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
        Grabando...
      </p>
      <p class="text-sm text-slate-500 dark:text-slate-400 font-mono mt-0.5">
        {{ formattedDuration() }}
      </p>
    </div>
  </div>
  } @default {
  <div class="flex items-center gap-3">
    @if (state() === 'playing') {
    <button
      type="button"
      class="w-14 h-14 rounded-full bg-primary text-white flex items-center justify-center shadow-lg shadow-primary/25 hover:bg-primary/90 active:scale-95 transition-all cursor-pointer shrink-0"
      (click)="pause()"
      aria-label="Pause"
    >
      <span
        class="material-symbols-outlined flex items-center justify-center !text-[24px] leading-none"
        >pause</span
      >
    </button>
    } @else {
    <button
      type="button"
      class="w-14 h-14 rounded-full bg-primary text-white flex items-center justify-center shadow-lg shadow-primary/25 hover:bg-primary/90 active:scale-95 transition-all cursor-pointer shrink-0"
      (click)="play()"
      aria-label="Play"
    >
      <span
        class="material-symbols-outlined flex items-center justify-center !text-[24px] leading-none"
        >play_arrow</span
      >
    </button>
    }
    <div class="flex-1 min-w-0">
      <p class="text-base font-semibold text-slate-700 dark:text-slate-300">
        {{ title() || 'Audio' }}
      </p>
    </div>
    <button
      type="button"
      class="w-10 h-10 rounded-lg text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors cursor-pointer flex items-center justify-center shrink-0"
      (click)="clearAudio()"
      aria-label="Delete audio"
    >
      <span
        class="material-symbols-outlined flex items-center justify-center !text-[20px] leading-none"
        >delete</span
      >
    </button>
  </div>
  } } } @if (!readOnly()) {
  <div class="mt-4 flex items-center gap-3 waveform-row w-full">
    <div
      class="flex-1 min-w-0 w-full waveform-canvas"
      [style.height.px]="height()"
      [style.min-height.px]="height()"
      #waveformContainer
    ></div>
    @if (state() === 'recorded' || state() === 'playing' || state() ===
    'paused') {
    <span class="text-sm text-primary font-mono shrink-0">
      {{ formattedCurrentTime() }} / {{ formattedDuration() }}
    </span>
    }
  </div>
  }
</div>
